import { UPDATE_DISPLAYED_PROPERTIES } from 'actions/properties';

export default (state = [], action) => {
	switch (action.type) {
		case UPDATE_DISPLAYED_PROPERTIES:
			return action.payload;
		default:
			return state;
	}
};